import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  line: {
    borderRadius: 10,
  },
}));

const LinearCompletion = ({ value, label }) => {
  const classes = useStyles();

  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress className={classes.line} variant="determinate" value={value} />
      </Box>
      <Box style={{ whiteSpace: 'nowrap' }}>
        <Typography variant="body2" color="textSecondary">
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default LinearCompletion;
